import { render, staticRenderFns } from "./servermem.vue?vue&type=template&id=3eb76cf6"
import script from "./servermem.vue?vue&type=script&lang=js"
export * from "./servermem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports